<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  watch: {
    "$store.state.idleVue.isIdle": function () {
      this.$store.dispatch("logoutUser");
      // console.log(this.$store.state.idleVue.isIdle);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// resources/js/main.vue